import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import _ from 'lodash';

const ProfileItem = ({ title, content, contentUrl, showPrimaryFlag = false }) => {
  ProfileItem.propTypes = {
    title: PropTypes.string,
    content: PropTypes.string,
    contentUrl: PropTypes.string,
    showPrimaryFlag: PropTypes.bool
  };
  return <div className='profile-item-container'>
    <div className='profile-item-body'>
      <div>
        <span className='profile-item profile-item-title'>{title}</span>
        {
          showPrimaryFlag && <span className='status-indicator'>PRIMARY</span>
        }
      </div>
      {
        !contentUrl
          ? <span className='profile-item profile-item-content'>{content}</span>
          : <a className='profile-item profile-item-content' href={contentUrl}>{content}</a>
      }
    </div>
  </div>;
};

class UserProfileUI extends React.Component {
  static propTypes = {
    userprofile: PropTypes.object.isRequired,
    redirectTo: PropTypes.func.isRequired
    // outOfOffice: PropTypes.shape({
    //   startDateTime: PropTypes.string,
    //   endDateTime: PropTypes.string
    // })
  }

  handleOOOSelection = () => {
    this.props.redirectTo('/userprofile/outofoffice');
  }

  render () {
    const { userprofile = {} } = this.props;
    // const startingDate = moment(new Date(outOfOffice.startDateTime));
    // const endingDate = moment(new Date(outOfOffice.endDateTime));

    // const startDate = startingDate.format('MMM') + ' ' + startingDate.format('DD');
    // const endDate = endingDate.format('MMM') + ' ' + endingDate.subtract(1, 'd').format('DD');

    return (
      <React.Fragment>
        {/* <div className='profile-content-sub-header'>My Account</div>
        <div className='profile-ooo-wrapper' onClick={this.handleOOOSelection}>
          <div className='profile-ooo-title'> Out of Office </div>
          { !!outOfOffice.startDateTime &&
          <div className='profile-ooo-date'>
            {`${startDate} - ${endDate}`}
          </div>
          }
          <div><i className='icon-arrow-right profile-icon' /></div>
        </div> */}

        {/* <i className='material-icons menu-right font-size-big' /> */}
        <div className='profile-content-sub-header'>Personal Information</div>
        <ProfileItem title='Full Name' content={`${userprofile.memberFirstName} ${userprofile.memberLastName}`} />
        <ProfileItem title='Login' content={userprofile.memberEmail} />
        <ProfileItem title='Home Address' content={userprofile.memberAddress1}
          showPrimaryFlag={userprofile.isHomeAddressPrimary != null && userprofile.isHomeAddressPrimary} />
        <ProfileItem title='Mobile Phone' content={_.isEmpty(userprofile.memberMobilePhone) ? '' : userprofile.memberMobilePhone} />
        <ProfileItem title='Primary Email Address' content={userprofile.memberEmail} />
        <div className='profile-content-sub-header'>Office Related Information</div>
        <ProfileItem title='Primary Office Name' content={userprofile.officeName} />
        <ProfileItem title='Office Address' content={userprofile.officeAddress1}
          showPrimaryFlag={userprofile.isHomeAddressPrimary == null || !userprofile.isHomeAddressPrimary} />
        <ProfileItem title='Office Phone' content={userprofile.officePhone} />
        <ProfileItem title='Marketing Name' content={userprofile.officeMarketingName ? userprofile.officeMarketingName : userprofile.officeName} />
        <ProfileItem title='Website' content={userprofile.officeWebsite} contentUrl={userprofile.officeWebsite} />
        <ProfileItem title='NAR Designations' content={userprofile.officeNARDesignations} />
        <ProfileItem title='Xome Designations' content={userprofile.officeXomeDesignations} />
      </React.Fragment>
    );
  }
}

export default withRouter(UserProfileUI);
